enum TabPaths {
  Metrics = 'metrics',
}

export default TabPaths;
